import { Box } from '@mui/material';
import React from 'react';
import { SpaceOption } from '../../types';
import { SpaceSelector } from './SpaceSelector';

interface VectorMemoryFormProps {
  selectedSpaceId: string;
  onSpaceChange: (value: string) => void;
  spaces: SpaceOption[];
  disabled?: boolean;
}

export const VectorMemoryForm: React.FC<VectorMemoryFormProps> = ({
  selectedSpaceId,
  onSpaceChange,
  spaces,
  disabled = false,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <SpaceSelector
        value={selectedSpaceId}
        onChange={onSpaceChange}
        spaces={spaces}
        disabled={disabled}
      />
    </Box>
  );
};
